import * as React from 'react'
import { useNavigate, useOutletContext } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { PlanningVersionsPageDocument } from 'generated/resources/graphql'
import moment from 'moment'

import { observer } from 'mobx-react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useAsyncCan } from 'modules/core/lib/useAsyncCan'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import type Employee from 'modules/employees/store/models/Employee'
import Id from 'modules/time_planning/components/Id'
import { usePlanningVersions } from 'modules/time_planning/store/collections/planningVersions'
import type PlanningVersion from 'modules/time_planning/store/models/PlanningVersion'

const IndexReal = observer(() => {
  const { navigation } = useNavigation()

  const { employee, planningVersion } = useOutletContext<{
    employee: Employee
    planningVersion: PlanningVersion | null | undefined
  }>()

  const navigate = useNavigate()
  const { value: authorized } = useAsyncCan('planning_versions.read', employee)

  const { loading } = useAsyncData(
    () => contractVersions.fetch({ withCachedFetchParams: true }),
    []
  )

  if (!authorized) navigate(navigation.employees.id.fullPath({ id: employee.id }))

  const planningVersions = usePlanningVersions()

  const getPlanningVersion = () => {
    if (planningVersion) return planningVersion

    return planningVersions.currentEmployeePlanningVersionWithinDate(moment(), employee.id)
  }

  const selectedPlanningVersion = getPlanningVersion()

  const { data, loading: loadingPolicies } = useQuery(PlanningVersionsPageDocument)

  const canManageCompanySchedules = data?.workSchedule._policies.manageCompanySchedules.can ?? false

  if (loading || loadingPolicies || !selectedPlanningVersion) {
    return (
      <Box alignItems="center" width="full" padding="s32">
        <Spinner />
      </Box>
    )
  }

  return (
    <Id
      planningVersion={selectedPlanningVersion}
      employee={employee}
      contractVersions={contractVersions}
      canManageCompanySchedules={canManageCompanySchedules}
    />
  )
})

const PlanningVersionsPage = () => <IndexReal />

export default PlanningVersionsPage
